import type { IPostFilter, IPostFilterModel } from '@/types/Data'
import type { IPayloadPostFilter } from '@/types/Request/PostAPI'
import BaseService from '../BaseService'

export default class PostFilterServices extends BaseService {
  GetPostFilterList() {
    return this.GET<IPostFilterModel | null>(this.PATHS.GET_POST_FILTER_LIST, { IsWeb: false })
  }

  CreatePostFilter(payload: IPayloadPostFilter) {
    return this.POST<IPostFilter>(this.PATHS.CREATE_POST_FILTER, payload)
  }

  UpdatePostFilter(payload: IPayloadPostFilter) {
    return this.PUT<IPostFilter>(this.PATHS.UPDATE_POST_FILTER, payload)
  }

  DeletePostFilter(Id: string) {
    return this.DELETE<boolean>(this.PATHS.DELETE_POST_FILTER, { Id })
  }
}
